import React, { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import Navbar from './Navbar/Navbar';
import DropdownButton from './DropdownButton/DropdownButton';
import { useTranslation } from 'react-i18next';
import Sidebar from './Sidebar/Sidebar';
import channelService from "../../Services/channelService";
import { useSelector } from 'react-redux';
import "./Header.css"

const Header = () => {
    const [show, setShow] = useState(false);
    const [channelList, setChannelList] = useState([]);

    const { t } = useTranslation();

    const { FirstName, LastName } = useSelector(state => state.user) || "";

    const navigate = useNavigate();

    useEffect(() => {
        (async () => {
            try {
                const { status, data } = await channelService.getChannel();
                if (status === 401) {
                    navigate("/access-denied");
                    return;
                }
                setChannelList(data);
            } catch (error) {
                console.error("Errore nel recupero del channel:", error);
            }
        })();
    }, []);

    const toggleSidebar = () => {
        setShow(prevState => !prevState);
    }

    return (
        <>
            <div className="d-flex flex-column justify-content-center align-items-center costa-header text-uppercase">
                <div className="header-items container fluid">
                    <div className="costa-header-top container">
                        <div className="header-top-items d-flex flex-row align-items-center">
                            <Link to="/" className='text-decoration-none header-link'>{t('media_center')}</Link>
                            <div className='d-flex flex-row align-items-center'>
                                <DropdownButton channelList={channelList} />
                                <div className='user d-none d-md-block'><i className="bi bi-person-fill"></i><span>&nbsp;{FirstName} {LastName}</span></div>
                            </div>
                        </div>
                    </div>
                    <Navbar showSidebar={toggleSidebar} />
                </div>
            </div>
            <Sidebar showMenu={show} channelList={channelList} />
        </>
    )
}

export default Header